export default __webpack_public_path__ + "static/media/Bonesoul Ale.601007b3.jpg";